export default __webpack_public_path__ + "static/media/classroom-icon.bbaec1f5.svg";